/* eslint-disable */
export default {
  from: 'Van',
  to: 'Aan',
  enterNameOrNumber: 'Nummer of naam invoeren...',
  typeMessage: 'Bericht typen...',
  send: 'Verzenden',
  emoji: 'Emoji',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
